var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "26px",
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 49") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-693.000000, -1130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(693.000000, 1130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(0.000000, 13.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7041016,11.3797607 C18.9467175,8.99646612 18.6731986,7.06494757 17.8835449,5.58520508 C17.3104684,4.51130937 15.1808287,3.18026192 13.6208496,1.48937988 C13.227818,1.06336767 13.0268089,0.56690771 13.0178223,0",
    id: "Path-110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70410156,11.3797607 C8.94671746,8.99646612 8.67319858,7.06494757 7.88354492,5.58520508 C7.3104684,4.51130937 5.18082869,3.18026192 3.62084961,1.48937988 C3.22781797,1.06336767 3.02680885,0.56690771 3.01782227,0",
    id: "Path-110",
    transform: "translate(5.903729, 5.689880) scale(-1, 1) translate(-5.903729, -5.689880) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.654907227,11.84729 L21,11.84729",
    id: "Path-111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(10.500000, 7.000000) scale(1, -1) translate(-10.500000, -7.000000) ",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7041016,12.3797607 C18.9467175,9.99646612 18.6731986,8.06494757 17.8835449,6.58520508 C17.3104684,5.51130937 15.1808287,4.18026192 13.6208496,2.48937988 C13.227818,2.06336767 13.0268089,1.52180273 13.0178223,0.864685059",
    id: "Path-110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70410156,12.3797607 C8.94671746,9.99646612 8.67319858,8.06494757 7.88354492,6.58520508 C7.3104684,5.51130937 5.18082869,4.18026192 3.62084961,2.48937988 C3.22781797,2.06336767 3.02680885,1.52180273 3.01782227,0.864685059",
    id: "Path-110",
    transform: "translate(5.903729, 6.622223) scale(-1, 1) translate(-5.903729, -6.622223) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.654907227,12.84729 L21,12.84729",
    id: "Path-111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(6.382568, 18.320923)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4 C9,1.790861 7.209139,0 5,0 C2.790861,0 1,1.790861 1,4",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(6.382568, 4.320923)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(4.397432, 2.599077) scale(1, -1) translate(-4.397432, -2.599077) translate(0.397432, 0.599077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.61743164,3.32092285 C6.61743164,1.6640686 5.27428589,0.320922852 3.61743164,0.320922852 C1.96057739,0.320922852 0.617431641,1.6640686 0.617431641,3.32092285",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61743164,3.32092285 C7.61743164,1.6640686 6.27428589,0.320922852 4.61743164,0.320922852 C2.96057739,0.320922852 1.61743164,1.6640686 1.61743164,3.32092285",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(2.000000, 3.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.22044605e-16,-1.2057022e-13 C0.740542037,0.49364027 1.30869796,1.01129978 1.70446777,1.55297852 C2.10023759,2.09465726 2.37111161,2.54704983 2.51708984,2.91015625 L2.63452148,0.23425293 L0.157226562,-1.2057022e-13",
    id: "Path-112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.4,-1.2057022e-13 C3.14054204,0.49364027 3.70869796,1.01129978 4.10446777,1.55297852 C4.50023759,2.09465726 4.77111161,2.54704983 4.91708984,2.91015625 L5.03452148,0.23425293 L2.55722656,-1.2057022e-13",
    id: "Path-112",
    transform: "translate(3.717261, 1.455078) scale(-1, 1) translate(-3.717261, -1.455078) "
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWaiting);
export default __webpack_public_path__ + "static/media/ico_waiting.9df43f9d04e1df02d450c4744d420fa3.svg";
export { ForwardRef as ReactComponent };